module.exports = __webpack_public_path__ + "img/bad.9b818848.svg";